const SwipeContainer = {
    mounted() {
        this.currentIndex = 0;
        this.startX = 0;
        this.currentX = 0;
        this.isDragging = false;
        this.container = this.el;
        this.wrapper = this.container.querySelector('[data-swipe-wrapper]');
        this.tabs = this.container.querySelectorAll('[data-swipe-tab]');
        
        this.container.addEventListener('touchstart', this.handleTouchStart.bind(this));
        this.container.addEventListener('touchmove', this.handleTouchMove.bind(this));
        this.container.addEventListener('touchend', this.handleTouchEnd.bind(this));

        this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.goToTab(index));
        });
    },

    handleTouchStart(e) {
        this.startX = e.touches[0].clientX;
        this.isDragging = true;
    },

    handleTouchMove(e) {
        if (!this.isDragging) return;
        
        this.currentX = e.touches[0].clientX;
        const diff = this.currentX - this.startX;
        const currentTranslate = -this.currentIndex * 100;
        const newTranslate = currentTranslate + (diff / this.wrapper.offsetWidth) * 100;
        
        const maxTranslate = 0;
        const minTranslate = -(this.wrapper.children.length - 1) * 100;
        const clampedTranslate = Math.max(minTranslate, Math.min(maxTranslate, newTranslate));
        
        this.wrapper.style.transition = 'none';
        this.wrapper.style.transform = `translateX(${clampedTranslate}%)`;
    },

    handleTouchEnd(e) {
        if (!this.isDragging) return;
        
        this.isDragging = false;
        const diff = this.currentX - this.startX;
        const threshold = 50;
        
        if (Math.abs(diff) > threshold) {
            if (diff > 0 && this.currentIndex > 0) {
                this.currentIndex--;
            } else if (diff < 0 && this.currentIndex < this.wrapper.children.length - 1) {
                this.currentIndex++;
            }
        }
        
        this.updatePosition();
        this.updateTabs();
    },

    goToTab(index) {
        this.currentIndex = index;
        this.updatePosition();
        this.updateTabs();
    },

    updatePosition() {
        this.wrapper.style.transition = 'transform 0.3s ease-out';
        this.wrapper.style.transform = `translateX(-${this.currentIndex * 100}%)`;
    },

    updateTabs() {
        this.tabs.forEach((tab, index) => {
            if (index === this.currentIndex) {
                tab.classList.add('border-primary', 'text-foreground');
                tab.classList.remove('border-transparent', 'text-foreground-soft');
            } else {
                tab.classList.remove('border-primary', 'text-foreground');
                tab.classList.add('border-transparent', 'text-foreground-soft');
            }
        });
    },

    destroyed() {
        this.container.removeEventListener('touchstart', this.handleTouchStart);
        this.container.removeEventListener('touchmove', this.handleTouchMove);
        this.container.removeEventListener('touchend', this.handleTouchEnd);
    }
};

export default SwipeContainer;
